module.exports = __webpack_public_path__ + "static/media/purefitout.e567b522.png";